import type { JSX } from 'react';

type SkipForwardIconProps = {
  className?: string;
};

const SkipForwardIcon = (props: SkipForwardIconProps): JSX.Element => {
  const { className } = props;
  return (
    <svg
      className={className || ''}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
    >
      <path
        fill="#121212"
        fillRule="evenodd"
        d="M19.168 2.708c.345 0 .625.28.625.625v5c0 .345-.28.625-.625.625h-5a.625.625 0 1 1 0-1.25h4.375V3.333c0-.345.28-.625.625-.625Z"
        clip-rule="evenodd"
      />
      <path
        fill="#121212"
        fillRule="evenodd"
        d="M10.97 3.195a6.875 6.875 0 1 0 5.516 9.097.625.625 0 0 1 1.179.417 8.126 8.126 0 1 1-1.92-8.457l3.85 3.627a.625.625 0 1 1-.856.91L14.88 5.155a6.875 6.875 0 0 0-3.911-1.96Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SkipForwardIcon;
